<template>
  <div class="od-card-container">
    <div class="odc-body-container">
      <div class="flex-row align-center">
        <input
          id="terms-checkbox"
          type="checkbox"
          :checked="termsAccepted"
          @change="handleTermsAccepted"
        >
        <label class="cb-label">
          I agree to <span @click="showTerms">terms and conditions</span>
        </label>
      </div>
      <div class="margin-top-4 flex-row align-center">
        <button
          type="button"
          class="pr-complete-btn"
          :disabled="!termsAccepted
            || calculatingTax"
          @click="handlePaymentMethod"
        >
          Complete
        </button>
        <div
          v-if="!order.billingAddress
            || !order.billingAddress.state
            || !order.billingAddress.zip
            || !order.billingAddress.country"
          class="odc-error-text margin-left-4"
        >
          Please fill out the billing address to complete
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import partnerReviewMixin from '@shared/mixins/partnerReviewMixin';

export default {
  name: 'OrderComplete',
  mixins: [partnerReviewMixin],
  methods: {
    handleTermsAccepted() {
      this.changePartnerReviewValue('termsAccepted', !this.termsAccepted);
    },
    handlePaymentMethod() {
      if (!this.selectedPaymentMethod.id) {
        this.toggleActionModal(true, 'new-payment-method');
      } else {
        this.toggleActionModal(true, 'payment-methods');
      }
    },
    showTerms() {
      this.toggleActionModal(true, 'terms');
    },
  },
};
</script>

<style lang="scss" scoped>

#terms-checkbox {
  width: 25px;
  height: 25px;
}

.cb-label {
  font-size: 1.125rem;
  margin-left: 8px;
  span {
    color: $NBLUE100;
    cursor: pointer;
  }
}

.pr-complete-btn {
  width: 200px;
  height: 48px;
  border-radius: 6px;
  background-color: $NBLUE100;
  color: $WHITE;
  font-weight: 600;
  &[disabled] {
    background-color: $N10;
  }
}

.odc-error-text {
  font-size: 0.875rem;
  color: $TOMATO100;
}
</style>
